/** Merge incoming realtime/API messages without duplicates or stale optimistic rows. */
export function upsertConsultingMessages(prev, incoming, currentUserId) {
  const list = Array.isArray(incoming) ? incoming : [incoming];
  let next = [...prev];
  for (const msg of list) {
    if (!msg?._id) continue;
    if (next.some((m) => m._id === msg._id)) continue;
    if (currentUserId && String(msg.senderId) === String(currentUserId)) {
      next = next.filter(
        (m) => !(String(m._id).startsWith("tmp-") && m.text === msg.text)
      );
    }
    if (!next.some((m) => m._id === msg._id)) next.push(msg);
  }
  return next;
}
